import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/index'
import Results from '@/pages/results'
import Patent from '@/pages/patent'
import Talent from '@/pages/talent'
import Subject from '@/pages/subject'
import Analysis from '@/pages/analysis'
import Details from '@/pages/details'
import Detail from '@/pages/newDetail'
import newList from '@/pages/newList'
import Personal from '@/pages/personal'
import Department from '@/pages/department'
import Login from '../pages/login.vue'

import CenterIndex from '@/pages/center/index'
import CenterCenter from '@/pages/center/center'
import CenterChina from '@/pages/center/china'
import CenterClaim from '@/pages/center/claim'
import CenterFollow from '@/pages/center/follow'
import CenterForeign from '@/pages/center/foreign'
import CenterPassword from '@/pages/center/password'
import CenterResult from '@/pages/center/result'
import CenterDrafts from '@/pages/center/drafts'
import CenterView from '@/pages/center/view'

Vue.use(Router);
const router=new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path:'/visualization',
      name:'visualization',
      component:resolve=>require(['../pages/fullScreenResize.vue'],resolve),
      meta:{
        showOnly:true
      }
    },
    {
      path: '/results',
      name: 'Results',
      component: Results
    },
    {
      path: '/patent',
      name: 'Patent',
      component: Patent
    },
    {
      path: '/talent',
      name: 'Talent',
      component: Talent
    },
    {
      path: '/subject',
      name: 'Subject',
      component: Subject
    },
    {
      path: '/analysis',
      name: 'Analysis',
      component: Analysis
    },
    {
      path: '/details',
      name: 'Details',
      component: Details
    },
    // 新冠详情
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    // 新冠列表
    {
      path: '/newList',
      name: 'newList',
      component: newList
    },
    {
      path: '/personal',
      name: 'Personal',
      component: Personal
    },
    {
      path: '/department',
      name: 'Department',
      component: Department
    },
    {
      path: '/center/index',
      name: 'CenterIndex',
      component: CenterIndex
    },
    {
      path: '/center/center',
      name: 'CenterCenter',
      component: CenterCenter
    },
    {
      path: '/center/china',
      name: 'CenterChina',
      component: CenterChina
    },
    {
      path: '/center/claim',
      name: 'CenterClaim',
      component: CenterClaim
    },
    {
      path: '/center/follow',
      name: 'CenterFollow',
      component: CenterFollow
    },
    {
      path: '/center/foreign',
      name: 'CenterForeign',
      component: CenterForeign
    },
    {
      path: '/center/password',
      name: 'CenterPassword',
      component: CenterPassword
    },
    {
      path: '/center/result',
      name: 'CenterResult',
      component: CenterResult
    },
    {
      path: '/center/study',
      name: 'CenterStudy',
      component: resolve=>require(['../pages/center/study.vue'],resolve)
    },
    {
      path: '/center/drafts',
      name: 'CenterDrafts',
      component: CenterDrafts
    },
    {
      path: '/center/view',
      name: 'CenterView',
      component: CenterView
    }
  ]
})
router.beforeEach((to, from, next) => {
  if(to.name=='login'){
    next()
  }else if(!sessionStorage.getItem('islog')){
    next('/')
  }else{
    next()
  }
  
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js